<template>
  <v-app-bar app>
    <v-toolbar-title>
      <router-link to="/" class="site-title">
        <v-img :src="brandLogo" alt="Brand Logo" class="brand-logo" contain></v-img>
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <div class="desktop-menu" v-if="!isMobile">
      <v-btn text v-for="item in menuItems" :key="item.title" @click="navigateTo(item.route)" v-show="item.requiresAuth ? isUserLoggedIn : true">
        {{ $t(`siteHeader['${item.title}']`) }}
      </v-btn>

      <v-btn text @click="toggleWalletConnection">
        {{ isUserLoggedIn ? formattedWalletAddress : $t('siteHeader.connectWallet') }}
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ props }">
          <v-btn text v-bind="props">
            {{ selectedLanguageLabel }}
            <v-icon right>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="lang in languages" :key="lang.code" @click="changeLanguage(lang.code, lang.label)">
            <v-list-item-title :class="lang.label === selectedLanguageLabel ? 'selected-language' : ''">{{ lang.label }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <v-menu offset-y v-else>
      <template v-slot:activator="{ props }">
        <v-btn text v-bind="props">
          <v-icon>mdi-menu</v-icon>
          <v-icon right>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="item in menuItems" :key="item.title" @click="navigateTo(item.route)" v-show="item.requiresAuth ? isUserLoggedIn : true">
          <v-list-item-title>{{ $t(`siteHeader['${item.title}']`) }}</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="toggleWalletConnection">
          <v-list-item-title>
            {{ isUserLoggedIn ? formattedWalletAddress : $t('siteHeader.connectWallet') }}
          </v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item v-for="lang in languages" :key="lang.code" @click="changeLanguage(lang.code, lang.label)">
          <v-list-item-title :class="lang.label === selectedLanguageLabel ? 'selected-language' : ''">{{ lang.label }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  props: {
    isUserLoggedIn: Boolean,
    brandLogo: String,
    walletAddress: String,
    toggleWalletConnection: Function,
  },
  data() {
    return {
      menuItems: [
        { title: 'intro', route: '/' },
        { title: 'product', route: '/product/featured' },
        { title: 'team', route: '/' },
        { title: 'userCenter', route: '/dashboard', requiresAuth: true },
      ],
      languages: [
        { code: 'zhHant', label: '繁體' },
        { code: 'en', label: 'English' },
        { code: 'ko', label: '한국어' },
      ],
      selectedLanguageLabel: '繁體',
      isMobile: false,
    };
  },
  computed: {
    formattedWalletAddress() {
      if (!this.walletAddress) return '';
      return `${this.walletAddress.slice(0, 6)}.....${this.walletAddress.slice(-6)}`;
    },
  },
  mounted() {
    this.checkMobile();
    this.changeLanguage('zhHant', '繁體');
    window.addEventListener('resize', this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    navigateTo(route) {
      this.$router.push(route);
    },
    changeLanguage(lang, label) {
      this.selectedLanguageLabel = label;
      this.$emit('change-language', lang, label);
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
};
</script>

<style scoped>
.site-title {
  text-decoration: none;
  color: inherit;
}
.selected-language {
  color: #fc0a0a;
}
.brand-logo {
  height: 40px;
  max-width: 100%;
  object-fit: contain;
}

.desktop-menu {
  display: flex;
  align-items: center;
}

@media (max-width: 768px) {
  .desktop-menu {
    display: none;
  }
}
</style> 